import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DuplikitUndedupeService {
  unDedupingTasks: string[] = [];

  constructor(
    private http: HttpClient
  ) { }

  unDedupeByDedupeTaskId(dedupeTaskId: string) {
    return this.http.post<any>(`${environment.duplikitUrl}/Dedupe/unDedupeTaskByDedupeTaskId`,
      { dedupeTaskId: dedupeTaskId });
  }

  unDedupeTaskIsComplete(dedupeTaskId: string): Observable<boolean> {
    return this.http.post<boolean>(`${environment.duplikitUrl}/Dedupe/unDedupeTaskIsComplete`,
      { dedupeTaskId: dedupeTaskId });
  }

}
